import React, { useEffect, useState } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";
import AboutService from "../../services/AboutService";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
const Static = () => {
	const { t } = useTranslation();
	const [data, setData] = useState([]);
	const lang = useSelector((state) => state?.lang?.lang);
	const aboutService = new AboutService();
	const location = useLocation();

	useEffect(() => {
		aboutService
			?.getList({
				type:
					location?.pathname === "/privacy-policy"
						? "Privacy"
						: location?.pathname === "/terms-conditions"
							? "faqs"
							: "about",
			})
			.then((res) => {
				if (res?.status === 200) {
					setData(res?.data?.data[0] || {});
				}
			});
	}, [location?.pathname]);

	return (
		<div className="aboutUs">
			<div
				className="static-header"
				style={{ backgroundImage: `url(${data?.image})` }}>
				<motion.h5
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ delay: 0.25, duration: 1 }}
					className="type-title text-center">
					{location?.pathname === "/privacy-policy"
						? t("privacy_policy_return")
						: location?.pathname === "/terms-conditions"
							? t("term and conditions")
							: t("about-us")}
				</motion.h5>
			</div>
			<div>
				<div className="about-us">
					<motion.div
						initial={{ opacity: 0, y: 50 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 1 }}
						className="w-50 description">
						<h2 className="mb-4">
							{lang === "en" ? data?.title_en : data?.title_ar}
						</h2>
						<p
							dangerouslySetInnerHTML={{
								__html:
									lang === "en" ? data?.description_en : data?.description_ar,
							}}></p>
					</motion.div>
				</div>
			</div>
		</div>
	);
};

export default Static;
